import { useContext } from "react";
import { AppContext } from "./AppContext";

const useAppGlobal = () => useContext(AppContext);
export default useAppGlobal;
